// Section 8 — How It Works. Anchor id="how" (Header nav target).
const STEPS = [
  {
    n: '01',
    title: 'Pick your certification',
    body: 'Choose from CompTIA A+, Network+, Security+, AZ-104, and more. Each track is built around the actual exam objectives — and the actual jobs you can land with it.',
  },
  {
    n: '02',
    title: 'Learn through practice',
    body: "Lessons teach in short focused beats with built-in practice moments. You don't passively read — you predict, classify, and apply what you're learning as you go.",
  },
  {
    n: '03',
    title: 'Struggle? The system responds.',
    body: 'When you miss a concept, AdaptOS spots what tripped you up, changes the angle, and gives you targeted practice — before letting you advance.',
  },
  {
    n: '04',
    title: 'Master, then advance',
    body: "Mastery gates make sure you've actually got it before the next concept. Not 'passed a quiz' — actually understand it well enough to apply it on the job.",
  },
];

export default function HowItWorksSection() {
  return (
    <section className="hw-sec" id="how">
      <div className="hw-inner">
        <h2 className="hw-h2">How it works.</h2>
        <p className="hw-sub">Four steps. Real adaptation. No fluff.</p>

        <div className="hw-grid">
          {STEPS.map((s, i) => (
            <div className="hw-step-wrap" key={s.n}>
              <div className="hw-step">
                <span className="hw-num">{s.n}</span>
                <h3 className="hw-step-title">{s.title}</h3>
                <p className="hw-step-body">{s.body}</p>
              </div>
              {i < STEPS.length - 1 && <div className="hw-arrow" aria-hidden="true">›</div>}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .hw-sec {
          position: relative; z-index: 1;
          padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px);
          scroll-margin-top: 120px;
        }
        .hw-inner { max-width: 1160px; margin: 0 auto; }
        .hw-h2 {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(28px, 4vw, 44px); line-height: 1.1;
          letter-spacing: -0.02em; margin: 0; text-align: center;
        }
        .hw-sub {
          font-weight: 300; color: rgba(17,17,16,0.62);
          font-size: clamp(16px, 2vw, 20px); margin: 18px 0 0; text-align: center;
        }
        .hw-grid {
          margin-top: clamp(36px, 5vw, 56px);
          display: flex; align-items: stretch; justify-content: center;
        }
        .hw-step-wrap { display: flex; align-items: center; flex: 1; min-width: 0; }
        .hw-step {
          flex: 1; min-width: 0; height: 100%;
          background: #ffffff; box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          border: 1px solid rgba(0,0,0,0.08); border-radius: 16px;
          padding: 24px 20px; display: flex; flex-direction: column; gap: 10px;
          transition: border-color .2s ease, transform .2s ease;
        }
        .hw-step:hover { border-color: rgba(217,119,6,0.30); transform: translateY(-3px); }
        .hw-num {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: 34px; line-height: 1; color: #d97706;
        }
        .hw-step-title { font-size: 17px; font-weight: 700; color: #111110; margin: 4px 0 0; line-height: 1.3; }
        .hw-step-body { font-size: 14px; line-height: 1.55; color: rgba(17,17,16,0.64); margin: 0; }
        .hw-arrow {
          flex-shrink: 0; color: rgba(217,119,6,0.5);
          font-size: 30px; font-weight: 300; padding: 0 8px;
        }
        @media (max-width: 900px) {
          .hw-grid { flex-direction: column; align-items: stretch; max-width: 460px; margin-left: auto; margin-right: auto; }
          .hw-step-wrap { flex-direction: column; flex: none; }
          .hw-step { width: 100%; }
          .hw-arrow { transform: rotate(90deg); padding: 8px 0; }
        }
      `}</style>
    </section>
  );
}
